(function () {
  function removeStrayLessThan(wrap) {
    if (!wrap) return;

    // Remove text nodes that are exactly "<"
    Array.from(wrap.childNodes).forEach(function (n) {
      if (n.nodeType === Node.TEXT_NODE && n.textContent.trim() === '<') {
        n.remove();
      }
    });

    // Remove child elements that are exactly "<"
    Array.from(wrap.children).forEach(function (el) {
      if (el.children.length === 0 && (el.textContent || '').trim() === '<') {
        el.remove();
      }
    });

    // Also remove a stray sibling right after the wrapper
    var sib = wrap.nextSibling;
    while (sib && sib.nodeType === Node.TEXT_NODE && sib.textContent.trim() === '') {
      sib = sib.nextSibling;
    }
    if (sib && sib.nodeType === Node.TEXT_NODE && sib.textContent.trim() === '<') {
      sib.remove();
    }
    if (sib && sib.nodeType === Node.ELEMENT_NODE && (sib.textContent || '').trim() === '<' && sib.children.length === 0) {
      sib.remove();
    }
  }

  function cleanup() {
    document.querySelectorAll('.l4v-rating-badge').forEach(removeStrayLessThan);
  }

  document.addEventListener('DOMContentLoaded', cleanup);
  document.addEventListener('shopify:section:load', cleanup);

  // Lightweight follow-up for late-injected review widgets (Judge.me etc.)
  // (Avoid long-running subtree observers for performance.)
  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(cleanup, 600);
    setTimeout(cleanup, 1600);
  });
})();

/* L4V — Mobile mode flag (used by CSS: html.l4v-is-mobile) */
(function () {
  const root = document.documentElement;
  const mql = window.matchMedia('(max-width: 749px)');

  function apply() {
    root.classList.toggle('l4v-is-mobile', !!mql.matches);
  }

  apply();
  if (mql.addEventListener) {
    mql.addEventListener('change', apply);
  } else {
    // Safari fallback
    window.addEventListener('resize', apply);
  }
})();
/* NOTE:
   We intentionally avoid JS-based scrollbar compensation.
   It can cause visible "jumps" when drawers open/close.
   A CSS-only solution (scrollbar-gutter) is used in l4v-core.css. */
/* L4V: bottom secure-payments lock injector removed (now handled in Liquid) */
/* L4V — Remove empty alert shells in cart drawer (prevents blank white bars) */
(function () {
  function pruneEmptyCartAlerts() {
    const root = document.querySelector('#offcanvas-cart');
    if (!root) return;

    const candidates = root.querySelectorAll('.alert, [class*="alert"]');
    candidates.forEach((el) => {
      const raw = (el.textContent || '');
      const text = raw.replace(/[\s\u00A0]+/g, ''); // whitespace + &nbsp;
      const hasVisibleContent = text.length > 0;

      // Keep anything interactive
      const hasInteractive = el.querySelector('a, button, input, select, textarea');

      // If an "alert" is shown but contains no visible text and no interactive controls,
      // it's an empty placeholder bar. Hide it.
      if (!hasVisibleContent && !hasInteractive) {
        el.setAttribute('hidden', '');
        el.style.display = 'none';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', pruneEmptyCartAlerts);
  document.addEventListener('shopify:section:load', pruneEmptyCartAlerts);

  // Observe cart drawer updates
  const obs = new MutationObserver(() => pruneEmptyCartAlerts());
  document.addEventListener('DOMContentLoaded', () => {
    const cart = document.querySelector('#offcanvas-cart');
    if (cart) obs.observe(cart, { childList: true, subtree: true });
  });

  // Click fallback (some themes update after click handlers)
  document.addEventListener('click', () => setTimeout(pruneEmptyCartAlerts, 80));
})();

/* NOTE:
   We intentionally avoid JS-driven header offset/padding.
   It causes layout shift (content slides down after load).
   Mobile spacing is handled via CSS-only rules in l4v-core.css. */

/* L4V — Offcanvas: prevent background scroll WITHOUT changing viewport width
   Goal: eliminate the visible "zoom/shift" caused by scrollbar/padding compensation.
   Approach:
   - Keep the page scrollbar as-is (do NOT rely on overflow:hidden or padding-right hacks).
   - When an offcanvas/modal opens, block wheel/touch/key scrolling on the page,
     while still allowing scrolling inside the open panel.
   - Also strip any inline padding-right injected by Bootstrap (safety).
*/
(function () {
  var active = false;
  var scrubUntil = 0;

  function clearInlinePadding() {
    try {
      document.body.style.paddingRight = "";
      var els = document.querySelectorAll("html, body, .shopify-section-group-header-group, .sticky-top, .fixed-top, header");
      els.forEach(function (el) {
        if (el && el.style) el.style.paddingRight = "";
      });
    } catch (e) {}
  }

  function panelEl() {
    return document.querySelector(".offcanvas.show, .modal.show");
  }

  function isInsidePanel(target) {
    var p = panelEl();
    return p && target && target.closest && target.closest(".offcanvas.show, .modal.show");
  }

  function blockWheel(e) {
    if (!active) return;
    if (isInsidePanel(e.target)) return;
    e.preventDefault();
  }

  function blockTouch(e) {
    if (!active) return;
    if (isInsidePanel(e.target)) return;
    e.preventDefault();
  }

  function blockKeys(e) {
    if (!active) return;
    // Allow typing in inputs
    var tag = (e.target && e.target.tagName) ? e.target.tagName.toLowerCase() : "";
    if (tag === "input" || tag === "textarea" || tag === "select" || e.target.isContentEditable) return;

    // Keys that scroll the page
    var keys = ["ArrowUp","ArrowDown","ArrowLeft","ArrowRight","PageUp","PageDown","Home","End"," "];
    if (keys.indexOf(e.key) !== -1) {
      if (isInsidePanel(e.target)) return;
      e.preventDefault();
    }
  }

  function enableLock() {
    if (active) return;
    active = true;

    // If Bootstrap added overflow-hidden, remove it to keep viewport width stable.
    document.body.classList.remove("overflow-hidden");
    document.body.classList.remove("modal-open");

    scrub(420);

    // Non-passive listeners so we can preventDefault
    document.addEventListener("wheel", blockWheel, { passive: false, capture: true });
    document.addEventListener("touchmove", blockTouch, { passive: false, capture: true });
    document.addEventListener("keydown", blockKeys, { passive: false, capture: true });
  }

  function disableLock() {
    if (!active) return;
    active = false;
    document.removeEventListener("wheel", blockWheel, true);
    document.removeEventListener("touchmove", blockTouch, true);
    document.removeEventListener("keydown", blockKeys, true);
    scrub(220);
  }

  // During Bootstrap offcanvas open/close animations it may repeatedly inject
  // inline padding-right / overflow-hidden which causes the visible navbar wiggle.
  // We "scrub" those styles for a short window using rAF.
  function scrub(ms) {
    scrubUntil = Math.max(scrubUntil, Date.now() + (ms || 300));
    (function tick() {
      try {
        // Remove width-changing locks/compensation.
        document.body.classList.remove("overflow-hidden");
        document.body.classList.remove("modal-open");
        clearInlinePadding();
      } catch (e) {}

      if (Date.now() < scrubUntil) {
        requestAnimationFrame(tick);
      }
    })();
  }

  function onShow() {
    enableLock();
    scrub(520);
  }

  function onHide() {
    // Scrub immediately and during the closing animation, then release lock.
    scrub(520);
    setTimeout(function () {
      scrub(220);
      if (!panelEl()) disableLock();
    }, 120);
  }

  document.addEventListener("show.bs.offcanvas", onShow, true);
  document.addEventListener("hidden.bs.offcanvas", onHide, true);
  document.addEventListener("show.bs.modal", onShow, true);
  document.addEventListener("hidden.bs.modal", onHide, true);

  document.addEventListener("DOMContentLoaded", function () {
    if (panelEl()) enableLock();
  });
})();


(function(){
  function initWarmPetHouseGalleryFallback(scope){
    var roots = (scope || document).querySelectorAll('#product-template-l4v-premium[data-product-handle="warm-pet-house"] .product-gallery, #product-template[data-product-handle="warm-pet-house"] .product-gallery');
    roots.forEach(function(gallery){
      if (gallery.dataset.l4vGalleryFixed === 'true') return;
      gallery.dataset.l4vGalleryFixed = 'true';
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('.main-splide .splide__slide'));
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.thumbs-splide .splide__slide'));
      if (!slides.length) return;
      function activeIndex(){
        var idx = slides.findIndex(function(slide){ return slide.classList.contains('is-active') || slide.getAttribute('aria-hidden') === 'false'; });
        return idx >= 0 ? idx : 0;
      }
      function show(index){
        slides.forEach(function(slide, i){
          slide.style.display = (i === index ? 'flex' : 'none');
          slide.classList.toggle('is-active', i === index);
          slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });
        thumbs.forEach(function(thumb, i){
          thumb.classList.toggle('is-active', i === index);
          thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }
      show(activeIndex());
      thumbs.forEach(function(thumb, index){
        thumb.style.cursor = 'pointer';
        thumb.addEventListener('click', function(){ show(index); });
      });
      slides.forEach(function(slide){
        var obs = new MutationObserver(function(){ show(activeIndex()); });
        obs.observe(slide, {attributes:true, attributeFilter:['class','aria-hidden']});
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function(){ initWarmPetHouseGalleryFallback(document); });
  document.addEventListener('shopify:section:load', function(e){ initWarmPetHouseGalleryFallback(e.target || document); });
})();
